import { type GetHookResponse } from '../hooks'
import { useTantalimQuery } from '../query'
import { tagKey } from './keys'
import { HOUR, MINUTE, type TagData, type TagGetInput, type TagGetSuccess, type TagId } from '@terros/common'

const EMPTY_TAG_ID: TagId = 'Tag.EMPTY_TAG'

export function useTag(tagId?: TagId): GetHookResponse<TagData> {
  return useTantalimQuery<TagGetInput, TagGetSuccess, TagData>({
    url: '/tag/get',
    queryKey: tagKey(tagId),
    input: { tagId: tagId ?? EMPTY_TAG_ID },
    convertResponse: (data) => data.tag,
    options: {
      enabled: Boolean(tagId),
      staleTime: 30 * MINUTE,
      gcTime: HOUR,
      retry: false,
    },
  })
}
